export const video = [
    {
        id: 1,
        name: "Գործնական աշխատանք։ Մթնոլորտի պահպանումն աղտոտումից",
        info: "https://www.youtube.com/watch?v=KfHlwUSyxr8",
        menuItemId: 6
    },
    {
        id: 2,
        name: "Օդի Խոնավություն, խոնավացման գործակից",
        info: "https://www.youtube.com/watch?v=7NekeGWGtC4",
        menuItemId: 6
    },
    {
        id: 3,
        name: "Բրիտանիան պարտական է կատուներին",
        info: "https://www.youtube.com/watch?v=LzgBrONdMZY",
        menuItemId: 6
    },
    {
        id: 4,
        name: "Աշխարհագրական կորդինատներ ",
        info: "https://www.youtube.com/watch?v=VL5jaRJMucc",
        menuItemId: 6
    },



]